"use client"

import { ComponentConfig } from "@measured/puck"
import { Button } from "antd"
import "swiper/css"
import "swiper/css/pagination"
import { Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { twMerge } from "tailwind-merge"
import { configs, DefaultImage } from "../../../../external-components"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"
import "./css/custom-bullet.css"
import "./css/custom-navigation.css"

export interface SimpleSliderProps extends CommonStylesProps {
  slides: { id?: number; image?: string; url: string; titleSlideItem?: string }[]
  imageHeight?: number
  imageWidth?: number
  imageBorderRadius?: number
  spaceBetween?: number
  slidesPerView?: number
  loop?: boolean
  speed?: number
  timeDelay?: number
  isPagination?: boolean
  isNavigation?: boolean
  autoPlay?: boolean
  pagination?: "default" | "custom"
  breakpoint?: []
}

export const RenderConfig: ComponentConfig<SimpleSliderProps> = {
  // @TODO: missing responsive CSS @datvct

  render: ({
    slides,
    spaceBetween,
    slidesPerView,
    imageHeight,
    imageWidth,
    imageBorderRadius,
    loop,
    speed,
    timeDelay,
    pagination,
    styles,
    responsiveType,
    className,
    isPagination,
    isNavigation,
    autoPlay,
  }) => {
    const paginationCustom = {
      clickable: true,
      bulletClass:
        pagination === "default" ? "custom-swiper-pagination-bullet" : "custom-swiper-pagination-section-bullet",
      bulletActiveClass:
        pagination === "default"
          ? "custom-swiper-pagination-bullet-active"
          : "custom-swiper-pagination-section-bullet-active",
      renderBullet: function (index: number, className: string) {
        return `<span class="${className}">${""}</span>`
      },
    }

    const navigationCustomSKLStudio = {
      nextEl: ".custom-next-slick-arrow",
      prevEl: ".custom-prev-slick-arrow",
    }

    const id = `simple-slider-${Math.random().toString(36).substr(2, 9)}`

    // Merge default styles with user-defined styles
    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    // Generate responsive CSS
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <Swiper
          // spaceBetween={spaceBetween}
          slidesPerView={slidesPerView}
          pagination={paginationCustom}
          modules={[Navigation]}
          navigation={{
            nextEl: ".custom-next-slick-arrow",
            prevEl: ".custom-prev-slick-arrow",
          }}
          loop={loop}
          speed={speed}
          autoplay={{ delay: timeDelay }}
          className={`${id} ${twMerge(className)}`}
          // advance feature dành cho phase sau

          breakpoints={{
            0: {
              slidesPerView: 2.5,
              spaceBetween: 10,
              modules: [Pagination],
              slidesPerGroup: 1,
              // height: 200,
            },
            // 440: {
            //   slidesPerView: 2,
            //   spaceBetween: 20,
            //   // height: 300,
            // },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
              modules: [Navigation],
              slidesPerGroup: 4,
              // height: 300,
            },
          }}
        >
          {slides.map(({ id, image, url, titleSlideItem }, index) => (
            <SwiperSlide
              key={index}
              className="py-5 max-sm:pb-0 group hover:scale-110 transition-transform duration-300 w-[104px] ease-in-out transform "
            >
              <a
                href={url}
                target={url ? "_blank" : ""}
                rel="noopener noreferrer"
                className="relative w-full h-full block group rounded-[15px] text-center "
              >
                <div className=" transition-transform duration-300 ease-in-out transform group-hover:scale-105 rounded-[15px]">
                  <img
                    src={image ? `${configs.API_URL}${image}` : DefaultImage}
                    alt={`Slide ${index}`}
                    className={`sm:h-[104px] sm:w-[104px] object-cover md:w-[201px] md:h-[201px] rounded-[15px] md:rounded-[30px]`}
                  />
                </div>
                <h3 className="group-hover:scale-110 transition-transform duration-300 ease-in-out transform group-hover:text-[#3BC873] font-bold md:text-[15px] text-[12px] leading-[19px] py-[15px] max-sm:pb-0 px-2">
                  {titleSlideItem}
                </h3>
              </a>
            </SwiperSlide>
          ))}

          <Button
            className={`custom-prev-slick-arrow absolute opacity-80 left-5 z-10 top-[38%] p-0 h-[45px] w-[45px] rounded-[50%] transition-all duration-500 ease-out -translate-x-full lg:translate-x-0 -rotate-90 border-0 max-sm:hidden`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              id="Circle-Chevron-Up--Streamline-Lucide"
              height="60"
              width="60"
              className="opacity-10 scale-125"
            >
              <desc>Circle Chevron Up Streamline Icon: https://streamlinehq.com</desc>
              <path d="m4 8.75 3.5 -3.5 3.5 3.5" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></path>
            </svg>
          </Button>

          <Button
            className={`custom-next-slick-arrow absolute opacity-80 right-5 z-10 top-[38%] p-0 h-[45px] w-[45px] rounded-[50%] transition-all duration-500 ease-out -translate-x-full lg:translate-x-0 rotate-90 border-0 max-sm:hidden`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              id="Circle-Chevron-Up--Streamline-Lucide"
              height="60"
              width="60"
              className="opacity-10 scale-125"
            >
              <desc>Circle Chevron Up Streamline Icon: https://streamlinehq.com</desc>
              <path d="m4 8.75 3.5 -3.5 3.5 3.5" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></path>
            </svg>
          </Button>
        </Swiper>
      </>
    )
  },
}
